<template>
    <div class="dashboard__view mb-5">
      <div style="width: 100%; display: flex; justify-content: flex-end; align-items: center;">
        <div class="items-flex">
              <button class="btn woven-color pt-3 pb-4" @click.prevent="gotoUpload">Create</button>
            </div>
      </div>
      <div class="list">
        <div class="tab__content">
          <div class="tab__content__top">
            <div class="tab__content__top__left">
              {{ pageInfo.total }} blacklists
              <div class="tab__content__top__right">
                <div class="tab__content__top__item">
                  <button
                    @click="clearFilter"
                    class="btn btn--sm btn--default"
                    v-if="openFilters"
                  >
                    Clear Filter
                  </button>
                </div>
                <div class="tab__content__top__item">
                  <button
                    @click="openFilters = true"
                    class="btn btn--sm btn--default"
                  >
                    Filter
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
              class="tab__content__top"
              style="padding-top: 0"
              v-if="openFilters"
            >
              <div class="tab__content__top__left">.</div>
              <div class="tab__content__top__right">
                <form @submit.prevent="triggerFilter">
                  <div class="filter">
                    <div class="form__item">
                      <div class="form__label">Type</div>
                      <select v-model="filterList.type" class="form__input">
                        <option value="BVN">BVN</option>
                        <option value="NIN">NIN</option>
                        <option value="ACCOUNT_NUMBER">ACCOUNT_NUMBER</option>
                      </select>
                    </div>
                    <div class="form__item" style="padding-top: 33px">
                      <button
                        class="btn btn--primary btn--filter"
                        type="submit"
                      >
                        Apply Filter
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              </div>
          <EmptyState v-if="emptyState" type="not-found" icon="transaction" />
  
          <div v-else>
            <!-- Loader -->
            <div class="loader" v-if="loading">
              <span aria-hidden="true" class="spinner-border"></span>
            </div>
            <table class="table card-table" v-else>
              <thead>
                <tr>
                  <th>ID Number</th>
                  <th>name</th>
                  <th>type</th>
                  <th>source</th>
                  <th>added by</th>
                  <th style="text-align: left;">reason</th>
                  <th>delete</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  :key="item.id"
                  v-for="item in transactionList"
                >
                <td>{{ item.id_number}}</td>
                <td class="account-details">
                  {{ item.name || "Not Available" }}
                </td>
                <td>{{ item.type ? item.type : "Not Available" }}</td>
                <td>{{ item.source ? item.source : "Not Available" }}</td>
                <td>{{ item.addedBy ? item.addedBy : "Not Available" }}</td>
                <td style="text-align: left;">{{ item.reason ? item.reason : "Not Available" }}</td>
                <td @click="removeBlacklist(item)"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style="height: 12px;" fill="red"><path d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3zM32 128l384 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zm96 64c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16z"/></svg></td>
                </tr>
              </tbody>
            </table>
            <div
              class="table__details"
              v-if="loading !== true && emptyState !== true"
            >
              <div class="table__details__left">
                <span class="text-muted" v-if="pageInfo.total"
                  >Page {{ pageInfo.current_page }} of
                  {{ pageInfo.total_pages }}</span
                >
              </div>
              <div class="table__details__right">
                <Pagination :numberOfPages="pageInfo.total_pages" />
              </div>
              <div class="table__details__right"></div>
            </div>
          </div>
        </div>
      </div>
  
    </div>
  </template>
  
  <script>
  import AccountStatement from "@/components/accountStatementModal.vue";
  import { formatAmount } from "@/lib/formatAmount.js";
  import Pagination from "@/components/pagination.vue";
  export default {
    metaInfo: {
      title: "Merchant Details",
    },
    components: {
      AccountStatement,
      Pagination
    },
    data() {
      return {
        merchantList: {},
        merchantBalance: 0,
        loading: false,
        pageInfo: "",
        transactionList: "",
        emptyState: false,
      openFilters: false,
      filterList: {
        type: this.$route.query.type ? this.$route.query.type : ""
      },
      };
    },
  
    methods: {
      formatAmount,
      clearFilter() {
        this.filterList = {
          name: "",
          type: "",
          addedBy: "",
          source: "",
        };
        this.$router.push({ path: "/dashboard/blacklists?page=1" });
      },
      moment: window.moment,
      triggerFilter() {
        let queryObject = {};
        if (this.filterList.type !== "") {
          queryObject.type = this.filterList.type.trim();
        }
        queryObject.page = 1;
        this.openFilters = false;
        //Route to page with query
        this.$router.push({ path: "/dashboard/blacklists", query: queryObject });
      },
      removeBlacklist(index) {
        this.$http
          .delete(`blacklists?id_type=${index.type}&id_number=${index.id_number}`)
          .then(() => {
            this.$notify({
              group: "notifications-default",
              type: "success text-white",
              title: "Success",
              text: "Blacklist deleted successfully",
            });
            this.fetchTransactions();
          })
          .catch((error) => {
            this.loading = false;
            this.$notify({
              group: "notifications-default",
              type: "error text-white",
              title: "Error",
              text: error.body.message || "An error occured.",
            });
          });
      },
      fetchTransactions() {
        const page = this.$route.query.page || 1;
        const type = this.$route.query.type || '';
        this.loading = true;
        const url = `blacklists?page=${page}&limit=10&type=${type}`;
        this.$http
          .get(url)
          .then((response) => {
            if (response.body.data.blacklists.length > 0) {
              this.transactionList = response.body.data.blacklists;
              this.pageInfo = response.body.data.page_info;
              this.emptyState = false;
              this.loading = false;
            } else {
              this.emptyState = true;
              this.loading = false;
            }
          })
          .catch(() => {
            this.loading = false;
          });
      },
      gotoUpload() {
      this.$router.push('/dashboard/blacklists/upload');
    }
    },
    mounted() {
      this.fetchTransactions();
    },
    watch: {
        '$route.query'() {
            this.fetchTransactions();
        }
    }
  };
  </script>
  <style>
  .items-flex{
    width: fit-content !important;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 20px;
    margin-bottom: 1rem;
  }
  .items-flex > button{
    height: 40px;
    color: #e00b5b !important;
    border-radius: 4px !important;
    background-color: white !important;
    border: 1px solid #e00b5b !important;
  }
  .dropdown-item-list{
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .tab__content__top__left{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .green-status {
    color: #00b87c !important;
  }
  .red-status {
    color: #e00b5b !important;
  }
  .other-status{
    color: #FFBF00 !important;
  }
  .account-details{
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
  }
  .download-text{
    font-size: 12px;
    color: #A0A3BD;
    cursor: pointer;
  }
  </style>
  